import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const giftCardPurchasesApi = createApi({
    reducerPath: "giftCardPurchasesApi",
    tagTypes: ["giftCardPurchases"],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: (build) => ({
        getGiftCardPurchases: build.query({
            query: (data) => ({
                url: api.giftCardPurchases.getGiftCardPurchases(data.settingable_id),
                method: "GET",
                params: data,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ["giftCardPurchases"],
        }),
        createGiftCardPurchase: build.mutation({
            query: (data) => ({
                url: api.giftCardPurchases.createGiftCardPurchase(),
                method: 'POST',
                body: data
            }),
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled

                    dispatch(
                        giftCardPurchasesApi.util.updateQueryData('getGiftCardPurchases', patch, (draft) => {
                            draft.unshift(data)
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        getSingleGiftCardPurchase: build.query({
            query: ({id, ...params }) => ({
                url: api.giftCardPurchases.getSingleGiftCardPurchase(id),
                method: "GET",
                params
            }),
        }),
    }),
});

export const { useGetSingleGiftCardPurchaseQuery } = giftCardPurchasesApi;
